document.addEventListener("DOMContentLoaded", function () {
  // Select all menu items that have a submenu
  var menuItems = document.querySelectorAll(".site-nav .sub-menu .menu-item-has-children");

  // Iterate over each menu item
  menuItems.forEach(function (item) {
    // Create a new button element
    var button = document.createElement("button");
    button.textContent = ""; // Set the button text
    button.className = "toggle-submenu"; // Set the button class

    // Insert the button right after the <a> element within the li
    var anchor = item.querySelector("a"); // Find the first <a> within the item
    anchor.insertAdjacentElement("afterend", button); // Place the button after the <a>

    // Define click event for the button
    button.addEventListener("click", function () {
      // Get the direct child sub-menu of the current menu item
      var submenu = item.querySelector(".sub-menu");
      if (submenu) {
        // Toggle the display style between 'none' and 'block'
        submenu.style.display = submenu.style.display === "block" ? "none" : "block";
        // Toggle the 'open' class on the button
        button.classList.toggle("open");
      }
    });
  });
});
